<template>
  <div class="animated fadeIn col-md-12">
    <Search
      :url="url"
      :title="$lang.searchEnumList"
      config="enum"
      :toggleable="true"
      :allowRemove="false"
      :allowFields="$lang.searchEnum"
      :dynamicButtons="buttons"
      :filterCatch="true"
      :visibleAdd="true"
      :editable="false"
      ref="searchEnum"
      @getPermisson="updatePermissions"
    >
      <template slot="addModal" slot-scope="search">
        <b-card>
          <div slot="header">
            <strong v-text="$lang.add_new_enum" />
          </div>
          <AddEnum
            :permissions="permissions"
            @close="search.close"
            @getData="fetchData"
          />
        </b-card>
      </template>
    </Search>
    <b-modal
      no-close-on-backdrop
      v-model="view_edit_enum"
      ok-only
      hide-footer
      hide-header
    >
      <EditEnum
        :itemId="itemId"
        :permissions="permissions"
        @close="closeModal"
        @getData="fetchData"
      />
    </b-modal>
  </div>
</template>

<script>
import Search from "@/components/base/search";
import EditEnum from "./editEnum";
import AddEnum from "./addEnum";
import { generateApiUrl } from "@/shared/utils";

export default {
  name: "search-enum",
  components: {
    Search,
    AddEnum,
    EditEnum,
  },
  data() {
    return {
      loadingItem: false,
      url: generateApiUrl(["profile", "enum_editable"]),
      view_edit_enum: false,
      itemId: null,
      permissions: [],
      buttons: [
        {
          id: "0",
          name: "edit",
          click: this.openModal,
        },
        {
          id: "1",
          name: "view",
          click: this.openModal,
        },
      ],
    };
  },
  methods: {
    generateApiUrl,
    fetchData() {
      this.$refs.searchEnum.getItems();
    },
    closeModal() {
      this.view_edit_enum = false;
    },
    openModal(item) {
      this.itemId = item.id;
      this.view_edit_enum = true;
    },
    updatePermissions(permissions) {
      this.permissions = [...permissions];
    },
  },
};
</script>
